/* hs-eslint ignored failing-rules */
/* eslint-disable @typescript-eslint/no-floating-promises */

import { useEffect } from 'react';
import UILoadingSpinner from 'UIComponents/loading/UILoadingSpinner';
import { fetchAttachedContentWithContext } from '../data/attachedContentWithContext/thunks';
import { selectContentId } from '../data/content/slice';
import { selectIsFetchingAttachedCluster } from '../data/loading/slice';
import { selectAttachedCluster } from '../data/topicEditor/slice';
import { useDispatch, useSelector } from '../store';
import { AttachedState } from './AttachedState';
import { DropdownsContainer } from './DropdownsContainer';
import { jsx as _jsx } from "react/jsx-runtime";
export const TopicEditor = () => {
  const dispatch = useDispatch();
  const contentId = useSelector(selectContentId);
  const isFetchingAttachedCluster = useSelector(selectIsFetchingAttachedCluster);
  useEffect(() => {
    if (contentId) {
      dispatch(fetchAttachedContentWithContext({
        contentId
      }));
    }
  }, [dispatch, contentId]);
  const attachedCluster = useSelector(selectAttachedCluster);
  if (isFetchingAttachedCluster) {
    return /*#__PURE__*/_jsx(UILoadingSpinner, {
      layout: "centered",
      minHeight: 200
    });
  }
  if (attachedCluster) {
    return /*#__PURE__*/_jsx(AttachedState, {
      attachedCluster: attachedCluster
    });
  }
  return /*#__PURE__*/_jsx(DropdownsContainer, {});
};